import {db} from '../firebase'
import moment from 'moment';
// data inicial
const dataInicial = {
    loading: false,
    activo: false,
}

// types
const LOADING_MOMENT='LOADING_MOMENT'
const USUARIO_LEADS='USUARIO_LEADS'
const USUARIO_LEADS_ERROR='USUARIO_LEADS_ERROR'



// reducer
export default function usuarioComentarios (state = dataInicial, action) {
    switch(action.type){
        case LOADING_MOMENT:
            return {...state, loading: true}
        case USUARIO_LEADS:
            return {mjsstatus:true}
        case USUARIO_LEADS_ERROR:
            return {mjsstatus:false}
        default:
            return {...state}
    }
}


export const registrarComentarios = (data) => async(dispatch) => {
    console.log('Inicio registrarComentarios')
    dispatch({
        type: LOADING_MOMENT
    })
    try {
        //Consultar Contador
        const accountants = await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`)
        .doc('commentsCounter')
        .get();
        //console.log(accountants.data().count);
        const documenCont = accountants.data().count + 1
        const comentId = 'coment'+ documenCont
        //Crear comentario
        //var date = Date.now()
        //var dateFormata = date.toLocaleString()
        //console.log(dateFormata)
        function nombrePropio(name) {
            let nombre = name
            let cadena = nombre.toLowerCase().split(' ');
            for (var i = 0; i < cadena.length; i++) {
            cadena[i] = cadena[i].charAt(0).toUpperCase() + cadena[i].substring(1); }
            nombre = cadena.join(' ');
            return nombre
            }

         await db.collection(`${process.env.REACT_APP_COL_COMENTS}`).doc(comentId).set({
            date: moment(Date.now()).format('DD MMMM YYYY, h:mm:ss a'),
            userName: nombrePropio(data.userName),
            userCompany:data.mensaje,
            userType:data.userType,
            email:data.email.toLowerCase(),
            userPhone: data.phone,
            mensaje:data.mensaje,
            roll:'lead',
            userActive:'false',
            userPreferens:data.userPreferenCont,
            propietary:'bicci',
            acepTerminos:data.checked,
            delete:false,
            //     uid:data.uid,
            //     userLastName:data.userLastName,
         })
         try {
            const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`).get();
            const arrayData = accountants.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            //console.log(arrayData)
            const userExist = arrayData.filter(item => item.email === data.email.toLowerCase())
            //console.log(userExist)
            if(userExist.length > 0){
                //console.log('Existe en nuestra data')}else{
                //console.log('No Se Existe y se crean')
                await db.collection(`${process.env.REACT_APP_COL_CONTACTS}`).doc(data.email.toLowerCase()).set({
                    date: Date.now(),
                    userName: nombrePropio(data.userName),
                    userCompany:data.mensaje,
                    userType:data.userType,
                    email:data.email.toLowerCase(),
                    userPhone:  data.phone,
                    lead:true,
                    userPreferens:data.userPreferenCont,
                    propietary:'bicci',
                    acepTerminos:true,
                    //     uid:data.uid,
                    //     userLastName:data.userLastName,
                })
             }
            //.doc(res.user.uid)   
            //console.log(accountants.data().uid)
        } catch (error) {
            
        }
         await db.collection(`${process.env.REACT_APP_COL_ACCOUNTANS}`).doc('commentsCounter').set({count:documenCont})
        dispatch({
            type: USUARIO_LEADS,
            mjsstatus:true,
        })
        
    } catch (error) {
        console.log(error)
        dispatch({
            type: USUARIO_LEADS_ERROR, 
            mjsstatus:false,
        })
    }
}
